import { MedicalItemScreeningTest } from "@/Patient/Models/MedicalSummary/MedicalItemScreeningTest";

import img_icon_red_warning from "@/Globals/_images/icons/red-warning.png";

interface IScreeningTestWarningIconProps {
    screeningTest: MedicalItemScreeningTest;
}

class ScreeningTestWarningIcon extends React.Component<IScreeningTestWarningIconProps, any> {
    public render(): JSX.Element {
        if (!this.props.screeningTest.isOverdueWithoutInterpretation())
            return null;

        return (
            <span>
                <img
                    src={img_icon_red_warning}
                    className="overdue-icon"
                    title={cacheStore.GetString("OverdueWithoutInterpretationLabel")}
                    alt={cacheStore.GetString("OverdueWithoutInterpretationLabel")}
                />
            </span>
        );
    }
}

export { ScreeningTestWarningIcon };
